var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column3-container"},[_c('Header'),_c('Center',{attrs:{"price":_vm.linePrice}}),_c('Foot',{attrs:{"price":_vm.linePrice}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }